<template>
    <div>
        <div class="invisible-area">
          <div class="spacer-40"></div>
          <div class="part-line"></div>
          <div class="main-title">Plan PDF / Video</div>
          <div class="spacer-40"></div>
          <div class="b-btn">
              <a href="/pdf/PlayXRP_en.pdf">
                  <img src="/img/common/icon-pdf.png">
                  <p style="color:#d2caf3;">English PDF<br/>Download</p>
              </a>
              <a href="javascript:void(0);" @click="openYoutube('https://youtu.be/nIB2_MZgqkg')">
                  <img src="/img/common/icon-yt.png">
                  <p style="color:#d2caf3;">English<br/>Video</p>
              </a>
          </div>
          <div class="spacer-40"></div>
          <div class="part-line"></div>
          <div class="select-pdf-down">
              <a href="/pdf/PlayXRP_cn.pdf">
                  <img src="/img/common/icon-pdf.png">
                  <p>China</p>
              </a>
              <a href="/pdf/PlayXRP_id.pdf">
                  <img src="/img/common/icon-pdf.png">
                  <p>Indonesia</p>
              </a>
              <a href="/pdf/PlayXRP_ja.pdf">
                  <img src="/img/common/icon-pdf.png">
                  <p>Japan</p>
              </a>
              <a href="/pdf/PlayXRP_ko.pdf">
                  <img src="/img/common/icon-pdf.png">
                  <p>Korea</p>
              </a>
              <a href="/pdf/PlayXRP_pt.pdf">
                  <img src="/img/common/icon-pdf.png">
                  <p>Portugal</p>
              </a>
              <a href="/pdf/PlayXRP_ru.pdf">
                  <img src="/img/common/icon-pdf.png">
                  <p>Russia</p>
              </a>
              <a href="/pdf/PlayXRP_es.pdf">
                  <img src="/img/common/icon-pdf.png">
                  <p>Spain</p>
              </a>
              <a href="/pdf/PlayXRP_th.pdf">
                  <img src="/img/common/icon-pdf.png">
                  <p>Thailand</p>
              </a>
              <a href="/pdf/PlayXRP_vn.pdf">
                  <img src="/img/common/icon-pdf.png">
                  <p>Vietnam</p>
              </a>
          </div>
          <div class="spacer-40"></div>
          <div class="part-line"></div>
          <div class="select-pdf-down">
              <a href="javascript:void(0);" @click="openYoutube('https://youtu.be/9rku8QyyxKE')">
                  <img src="/img/common/icon-yt.png">
                  <p>China</p>
              </a>
              <a href="javascript:void(0);" @click="openYoutube('https://youtu.be/6r77UcINdnk')">
                  <img src="/img/common/icon-yt.png">
                  <p>Indonesia</p>
              </a>
              <a href="javascript:void(0);" @click="openYoutube('https://youtu.be/DuyyREjDklA')">
                  <img src="/img/common/icon-yt.png">
                  <p>Japan</p>
              </a>
              <a href="javascript:void(0);" @click="openYoutube('https://youtu.be/9RqSoGgaiwk')">
                  <img src="/img/common/icon-yt.png">
                  <p>Korea</p>
              </a>
              <a href="javascript:void(0);" @click="openYoutube('https://youtu.be/OCZBX7t0dv4')">
                  <img src="/img/common/icon-yt.png">
                  <p>Portugal</p>
              </a>
              <a href="javascript:void(0);" @click="openYoutube('https://youtu.be/VJv9QqmEilU')">
                  <img src="/img/common/icon-yt.png">
                  <p>Russia</p>
              </a>
              <a href="javascript:void(0);" @click="openYoutube('https://youtu.be/O76yIv17tJs')">
                  <img src="/img/common/icon-yt.png">
                  <p>Spain</p>
              </a>
              <a href="javascript:void(0);" @click="openYoutube('https://youtu.be/3TjFUNcMuhU')">
                  <img src="/img/common/icon-yt.png">
                  <p>Thailand</p>
              </a>
              <a href="javascript:void(0);" @click="openYoutube('https://youtu.be/8DQxbxntC4U')">
                  <img src="/img/common/icon-yt.png">
                  <p>Vietnam</p>
              </a>
          </div>
      </div>
      <div>
          <div class="spacer-40"></div>
          <div class="part-line"></div>
          <!--  03-04 추가  -->
          <div class="spacer-40"></div>
          <div class="telegram-box">
              <a href="javascript:void(0);" @click="openTeleGlobal">
                  <img src="/img/common/telegram.png">
                  <p>PlayRipple<br/>Global</p>
              </a>
              <a href="javascript:void(0);" @click="openTeleGlobalNotice">
                  <img src="/img/common/telegram.png">
                  <p>PlayRipple<br/>Global Notice</p>
              </a>
              <router-link to="/buy-xrp" type="button">
                  <img src="/img/common/xrp.png">
                  <p>Buy Ripple</p>
              </router-link>
          </div>
      </div>
    </div>
</template>
<script>
import Modal from "@/components/Modal.vue";
import {mapGetters} from "vuex";

export default {
    data: () =>{
        return {
            
        }
    },
    components: {
        Modal,
    },
    computed: {
        ...mapGetters(["isAuthenticated"]), /* store에 저장된 값을 가져온다. */
        ...mapGetters(["detail"]),  /* store에 저장된 값을 가져온다. */
        ...mapGetters(["user"]), /* store에 저장된 값을 가져온다. */
    },
    mounted() {

    },
    methods: {
        openTeleGlobal() {
            window.open("https://t.me/PlayRipple", '_blank');
        },
        openTeleGlobalNotice() {
            window.open("https://t.me/PlayRipple_Notice", '_blank');
        },
        openYoutube(url) {
            window.open(url, '_blank');
        },
        comma(val){
            return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },
    /*filters:{
        comma(val){
            return String(val).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }*/
};
</script>
<style>
    .invisible-area {
      display:none;
    }
    .select-pdf-down {
        padding: 5px 0 5px 0 !important;
        overflow:hidden;
        width:90%;
        margin:0 auto;
    }

    .select-pdf-down a {
        display:inline-block;
        margin:0 0 0 0;
        padding:10px 0 10px 10px;
        text-align:center;
        color:white !important;
        font-size:12px;
        width:24.16%;height:30px;
    }
    .select-pdf-down a:first-child{margin:0 0 0 0;color:white;}
    .select-pdf-down a:nth-child(2){margin:0 0 0 0;}
    .select-pdf-down a:nth-child(3){margin:0 0 0 0;}
    .select-pdf-down a:nth-child(4){margin:0 0 0 0;}
    .select-pdf-down a:nth-child(5){margin:0 0 0 0;}
    .select-pdf-down a:nth-child(6){margin:0 0 0 0;}
    .select-pdf-down a:nth-child(7){margin:0 0 0 0;}
    .select-pdf-down a:last-child{margin:0 0 0 0;}
</style>
